import { createSlice } from "@reduxjs/toolkit";

const pageIndexSlice = createSlice({
  name: "pageIndex",
  initialState: { index: 0 },
  reducers: {
    setPageIndex: (state, action) => {
      state.index = action.payload;
    },
  },
});

export const { setPageIndex } = pageIndexSlice.actions;
export default pageIndexSlice.reducer;
